// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nqkHb","colMin":"styles_colMin__1uzlx"};